import styled from "styled-components";
import { Form } from "formik";
import { device } from "../../../constants/mediaQueries";

export const StyledCVForm = styled.div`
  width: 100%;
  display: flex;
  justify-content: center;
`;

export const SPField = styled.div`
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
  width: 100%;

  &.sp-formik-calendar-container {
    min-width: 0;
  }

  label {
    font-weight: 600;
    font-size: 0.875rem;
  }

  .p-inputtext {
    padding: 0.45rem 0.75rem;
  }

  textarea {
    padding: 0.4rem 0.75rem;
  }

  .input-error-container {
    width: 100%;
    display: flex;
    flex-direction: column;
    gap: 0.3rem;

    &__error-msg {
      color: var(--red-700);
      font-size: 0.875rem;
    }
  }

  &.spfield--disabled {
    label {
      color: var(--gray-500);
    }
  }

  .text-area-count {
    display: flex;
    justify-content: flex-end;
    padding-right: 0.5rem;
  }
`;
